import { FC } from "react";
import { IMainBoxProps } from "./types";

export const MainBox: FC<IMainBoxProps> = ({ children }) => (
  <div className="flex flex-col mt-4 w-full px-2 sm:px-5">{children}</div>
);
